module.exports = __webpack_public_path__ + "static/media/si.14651cb5.png";